// extracted by mini-css-extract-plugin
export default {"grid":"grid__VepSpeciesSelector__9avL9","topSection":"topSection__VepSpeciesSelector__9avL9","loader":"loader__VepSpeciesSelector__9avL9"};